import React, { useEffect } from "react";
import Formatic, { Data, Events, Overrides } from "@transformd-ltd/sdk";

const PAGES = {
  "62870de18f813600142a64b9": "CONFIRMATION",
};

const selectorSubmitBtn = ".formatic-action-bar-root__submit";

const NeoEmitter = ({ getData }) => {
  return <React.Fragment />;
};

export default NeoEmitter;
